
import { Component, Prop, Vue } from 'vue-property-decorator';

import TextField from '../../../framework/fields/TextField.vue';
import DateField from '../../../framework/fields/DateField.vue';
import NumberField from '../../../framework/fields/NumberField.vue';
import { sharedState } from '../../../framework/state';

import { Vehicle } from '../../../../common/application/model/Vehicle';
import { ServiceInfoType } from '../../../../common/application/model/enums/ServiceInfoType';
import { VehicleDashboardItem } from '../../../../common/application/model/VehicleDashboardItem';

@Component({
    components: {
        TextField,
        NumberField,
        DateField,
    },
})
export default class UserServices extends Vue {
    @Prop(String) readonly registrationNumber!: string;

    shared = sharedState;
    local = {
        row: {
            vehicleRegistrationNumber: '',
        } as Vehicle,
        showInspectionNotification: false,
        items: [
            {
                key: '0',
                url: `service-info/${ServiceInfoType.BOOK_SERVICE}`,
                title: 'subtitle.bookService',
                icon: `${ServiceInfoType.BOOK_SERVICE}.svg`,
            },
            {
                key: '1',
                url: `service-info/${ServiceInfoType.RENTAL_CAR}`,
                title: 'subtitle.rentalCar',
                icon: `${ServiceInfoType.RENTAL_CAR}.svg`,
            },
            {
                key: '2',
                url: `service-info/${ServiceInfoType.TIRES}`,
                title: 'subtitle.tires',
                icon: `${ServiceInfoType.TIRES}.svg`,
            },
            {
                key: '3',
                url: `service-info/${ServiceInfoType.WASHES}`,
                title: 'subtitle.washes',
                icon: `${ServiceInfoType.WASHES}.svg`,
            },
            {
                key: '4',
                url: `service-info/${ServiceInfoType.INSURANCE}`,
                title: 'subtitle.insurance',
                icon: `${ServiceInfoType.INSURANCE}.svg`,
            },
            {
                key: '5',
                url: `service-info/${ServiceInfoType.FUEL}`,
                title: 'subtitle.fuel',
                icon: `${ServiceInfoType.FUEL}.svg`,
            },
            {
                key: '6',
                url: `service-info/${ServiceInfoType.ROAD_SERVICE}`,
                title: 'subtitle.roadService',
                icon: `${ServiceInfoType.ROAD_SERVICE}.svg`,
            },
            {
                key: '7',
                url: `service-info/${ServiceInfoType.CAR_POLICY}`,
                title: 'subtitle.carPolicy',
                icon: `${ServiceInfoType.CAR_POLICY}.svg`,
            },
            {
                key: '8',
                url: `service-info/${ServiceInfoType.CAR_CHANGE}`,
                title: 'subtitle.returnCar',
                icon: `${ServiceInfoType.CAR_CHANGE}.svg`,
            },
            {
                key: '9',
                url: `vehicle-usage`,
                title: 'subtitle.vehicleUsage',
                icon: `${ServiceInfoType.VEHICLE_USAGE}.svg`,
            },
            {
                key: '10',
                url: `service-info/${ServiceInfoType.VEHICLE_INSPECTION}`,
                title: 'subtitle.vehicleInspection',
                icon: `${ServiceInfoType.VEHICLE_INSPECTION}.svg`,
            },
            {
                key: '11',
                url: `service-info/${ServiceInfoType.CUSTOMER_SERVICE}`,
                title: 'subtitle.customerService',
                icon: `${ServiceInfoType.CUSTOMER_SERVICE}.svg`,
            },
        ] as VehicleDashboardItem[],
    };

    goToItem(item: VehicleDashboardItem) {
        this.$router.push(`${this.registrationNumber}/${item.url}`);
    }
}
